import MessageProxy from "./MessageProxy"
import config from "./config"

const mp = new MessageProxy()

const msg = Object.assign(Object.create(mp), {
  setConfig(cfg){
    config.setConfig(cfg)
  }
})

export default msg